import { ExaktValues } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/ExaktValues';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function Richtwert() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.label',
        )}
      </span>
      <span className="text-neutrals-900 font-semibold">
        {data.bezahlung.arbeitszeitkonto.stundenloehner.richtwert
          ? data.bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit ===
            'euro'
            ? `${data.bezahlung.arbeitszeitkonto.stundenloehner.richtwertEuro} ${t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEuro.suffix',
              )}`
            : data.bezahlung.arbeitszeitkonto.stundenloehner
                  .richtwertEinheit === 'stunden'
              ? `${data.bezahlung.arbeitszeitkonto.stundenloehner.richtwertStunden} ${t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertStunden.suffix',
                )}`
              : t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.zusammenfassung.true',
                )
          : t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.zusammenfassung.false',
            )}
      </span>
      {data.bezahlung.arbeitszeitkonto.stundenloehner.richtwert &&
        data.bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit ===
          'exakt' && <ExaktValues />}
    </>
  );
}
